import { useEffect } from 'react'

import { API_PREFIX } from '@/lib/http'
import { useAuthStore } from '@/stores/auth.store'

const RECONNECT_BASE_MS = 2_000
const RECONNECT_MAX_MS = 30_000

export const usePresenceProbe = () => {
  const accessToken = useAuthStore((state) => state.accessToken)

  useEffect(() => {
    if (!accessToken) return

    let source: EventSource | null = null
    let reconnectTimer: ReturnType<typeof setTimeout> | null = null
    let backoff = RECONNECT_BASE_MS
    let disposed = false

    const connect = () => {
      if (disposed) return
      const token = useAuthStore.getState().accessToken
      if (!token) return

      source = new EventSource(
        `${API_PREFIX}sse/presence?accessToken=${encodeURIComponent(token)}`,
      )

      source.addEventListener('connected', () => {
        backoff = RECONNECT_BASE_MS
      })

      source.addEventListener('heartbeat', () => {
        backoff = RECONNECT_BASE_MS
      })

      source.onerror = () => {
        source?.close()
        source = null
        const delay = backoff
        backoff = Math.min(backoff * 2, RECONNECT_MAX_MS)
        reconnectTimer = setTimeout(connect, delay)
      }
    }

    connect()

    return () => {
      disposed = true
      source?.close()
      if (reconnectTimer) clearTimeout(reconnectTimer)
    }
  }, [accessToken])
}
